import Secure from "@/secure/payload";
import { API_URLS } from "@/utils/constant/api.constant";
import { C_API } from "@/utils/helper/api";
import { useQuery } from "@tanstack/react-query";

interface ProfileInfoResponse {
  isEnabled: boolean;
  lastChecked: string;
}

const fetchProfileInfo = async (params: { key: string }): Promise<ProfileInfoResponse> => {
  const response = await C_API.get(API_URLS.PROFILE.GET_INFO, { params: params });
  return response.data?.data;
};

export const useProfileInfo = (params: { key: string; orgId?: string }) => {
  return useQuery<ProfileInfoResponse, Error>({
    queryKey: ["profileInfo"],
    queryFn: () => fetchProfileInfo(params),
    refetchInterval: 0,
    staleTime: 0,
  });
};

const fetchDocumentsInfo = async (): Promise<ProfileInfoResponse> => {
  const response = await C_API.get(API_URLS.DOCS.AND_UPDATE_DOCUMENT);
  return response.data?.data;
};

export const useDocumentsInfo = () => {
  return useQuery<ProfileInfoResponse, Error>({
    queryKey: ["documentsInfo"],
    queryFn: fetchDocumentsInfo,
    refetchInterval: 0,
    staleTime: 0,
  });
};

const fetchSignatoryInfo = async (params: { key: string }): Promise<ProfileInfoResponse> => {
  const response = await C_API.get(API_URLS.SIGNATORY_AND_LETTERHEAD.GET_SIGNATARY_AND_LETTER_HEAD, {
    params: params,
  });
  return response.data?.data;
};

export const useSignatoryAndLetterHeadInfo = (params: { key: string }) => {
  return useQuery<ProfileInfoResponse, Error>({
    queryKey: ["signatoryInfo", params],
    queryFn: () => fetchSignatoryInfo(params),
    refetchInterval: 0,
    staleTime: 0,
    enabled: false,
    retry: false,
  });
};

export const updateMyProfile = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.put(API_URLS.PROFILE.UPDATE_MY_PROFILE, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};
export const updateOrgProfile = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.put(API_URLS.PROFILE.UPDATE_ORG_PROFILE, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const addUpdateDocument = async (docs: any) => {
  const encryptData = docs.map((d: any) => Secure.payloadEncryption(d));
  try {
    const response = await C_API.post(API_URLS.DOCS.AND_UPDATE_DOCUMENT, { docs: encryptData });
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const addUpdateSignatory = async (dataObj: any) => {
  try {
    const response = await C_API.post(API_URLS.SIGNATORY_AND_LETTERHEAD.ADD_UPDATE_SIGNATORY, dataObj);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const addUpdateLetterHead = async (dataObj: any) => {
  try {
    const response = await C_API.post(API_URLS.SIGNATORY_AND_LETTERHEAD.AND_UPDATE_LETTER_HEAD, dataObj);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};
